import { QUERY_MODIFICATION_REASONS } from '../../../../utils/constants';

export const TRANSLATION_KEYS_MAPPER = {
    [QUERY_MODIFICATION_REASONS.SPELLCHECK]: 'search_perseus.search_results_counter.search_instead',
    [QUERY_MODIFICATION_REASONS.SEMANTIC_REDIRECT]: 'search_perseus.search_results_counter.search_instead',
};
